var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.login_info && _vm.is_show_sidebar)?_c('AppSidebar'):_vm._e(),(_vm.login_info && _vm.is_show_sidebar)?_c('v-main',[_c('v-container',{staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1):_c('router-view'),_c('vtoast',{ref:"vtoast"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }